<template>
    <el-dialog
     :visible.sync="visible"
     width="25%"
     center
     append-to-body
     @close="closeDialog">
        <el-input v-model="lessonCode" placeholder="请输入上课码"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" class="inClassroomBtn" @click="inClassroom">进入课堂</el-button>
        </span>
    </el-dialog>
</template>
<script>
import communityApi from '@/request/api/community';

export default {
    props: {
        lessonId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            visible: false,
            lessonCode: ""
        }
    },
    methods: {
        //进入课堂
        inClassroom() {
            if(this.lessonCode != '') {
                communityApi.attendClassByClassCode(this.lessonCode, res => {
                    if(res.succeed) {
                        if(res.data == null || res.data) {
                            this.$router.push({ name: 'sh', query: { lessonId: this.lessonId }});
                        } else {
                            this.$router.push('/sh');
                        }
                    }
                })
            }
        },
        closeDialog() {
            this.lessonCode = "";
            this.lessonId = "";
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/dialog/codeDialog.vue